import { OdataFilters, queryCollection } from "helpers/reqparams";
import { request } from "services/request";

const resource = "api/mobileApp";

const mobileAppRatings = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter });
    return request(`${resource}/getRatingsList${query}`, { method: "GET" }, { countInHeaders: true });
};

export { mobileAppRatings };
